import type { ReactNode } from 'react';

interface HeaderFieldProps {
  label: string;
  value: ReactNode;
}

/**
 * Label/value pair for the row under a summary page's `PageHeader` title
 * (e.g. Title Summary's "Year of production", Client Summary's
 * "Representation"). Shared so both summary pages keep the same weight.
 */
export const HeaderField = ({ label, value }: HeaderFieldProps) => (
  <div className="flex flex-col gap-0.5">
    <span className="text-sm font-medium leading-5">{label}</span>
    <span className="text-sm font-normal leading-5 text-muted-foreground">
      {value}
    </span>
  </div>
);
